import { Row, Col, Container, Button } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../../auth/Style.css";
import SwiperCore, { Navigation, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import toast, { Toaster } from "react-hot-toast";
import { useEffect, useState } from "react";
import axios from "axios";
import { Carousel } from "react-responsive-carousel";
import CarouselN from "react-bootstrap/Carousel";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const ScannedQrcDetailsLostFound = () => {
  let navigate = useNavigate();
  const params = useParams();
  const [qrc, setQrc] = useState(null);
  const [scan, setScan] = useState("")
  const [userLocation, setUserLocation] = useState({
    latitude: null,
    longitude: null,
  });
  const [error, setError] = useState(null);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setError(null);
        },
        (error) => {
          setError(error.message);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  };

  const splitFileLink = (a) => {
    const x = a.split("_");
    const y = x[x.length - 1];
    return decodeURIComponent(y);
  };

  const handleGenerateQrc = async () => {
    // e.preventDefault();
    const scanId = new URLSearchParams(window.location.search).get("scanId");
    setScan(scanId)
    if (!userLocation?.latitude) return;
    const dataToSent = {
      scanId: scanId,
      lat: userLocation?.latitude,
      lon: userLocation?.longitude,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/scan/${params?.qrcid}`,
        dataToSent
      );
      // toast.success(response?.data?.message);
      setQrc(response?.data?.data?.qrcContentData);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
  useEffect(() => {
    getLocation();
    if (userLocation) {
      handleGenerateQrc();
    }
  }, [!userLocation?.latitude]);
  // useEffect(() => {
  //    if (qrc?.qrcContentId?.userDeviceId?.isLost == false && qrc?.destinationUrl) {
  //       window.location.replace(qrc?.destinationUrl)
  //    }
  // }, [qrc])

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <section className="d-flex justify-content-center ">
        <Container
          className="p-0"
          style={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Row
            className="no-gutters w-100 px-1"
            style={{
              borderRadius: "10px",
              justifyContent: "center",
              display: "flex",
              margin: "20px",
            }}
          >
            {qrc?.qrcContentId?.userDeviceId?.rewardAmount ? (
              <Col
                md="12"
                className=" d-flex flex-column justify-content-around "
                style={{ height: "100vh" }}
              >
                <div>
                  <div className="text-center">
                    <img
                      src={
                        qrc?.qrcContentId?.displayPhotoLink
                          ? qrc?.qrcContentId?.displayPhotoLink
                          : "/profile.png"
                      }
                      alt="img"
                      className="rounded-circle"
                      style={{ height: "60px", width: "60px" }}
                    />
                  </div>
                  <div className="d-flex flex-column justify-content-between align-items-center mt-1">
                    <div className="mt-3 d-flex justify-content-center flex-column align-items-center">
                      <b style={{ fontSize: "15px" }}>You’ve scanned for </b>
                      <b style={{ fontSize: "20px" }}>
                        {qrc?.qrcContentId?.lostAndFoundContent?.displayName}
                      </b>
                    </div>
                    <div
                      className="text-danger p-1 px-4"
                      style={{
                        fontSize: "18px",
                        border: "2px solid #e9e9e9",
                        fontSize: "18px",
                        borderRadius: "120px ",
                      }}
                    >
                      {qrc?.qrcContentId?.userDeviceId?.itemName}
                    </div>

                    <div className="mt-2 text-center">
                      <h4>
                        <b>
                          Returning this item to get a reward of $
                          {qrc?.qrcContentId?.userDeviceId?.rewardAmount}{" "}
                        </b>
                      </h4>
                    </div>
                    <CarouselN style={{ maxWidth: "600px", margin: "0 auto" }}>
                      {qrc?.qrcContentId?.userDeviceId?.devicePhotos?.map(
                        (photo, photoIndex) => (
                          <CarouselN.Item key={photoIndex}>
                            <img
                              className="d-block w-100"
                              src={photo}
                              alt={`post-photo-${photoIndex}`}
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          </CarouselN.Item>
                        )
                      )}
                    </CarouselN>
                  </div>
                </div>
                <div className="d-flex flex-column gap-4 w-100">
                  <Link
                    to={`/lost-qrc-add-details/${qrc?.qrcContentId?.userDeviceId?._id}/${scan}`}
                    className="text-white"
                  >
                    {" "}
                    <Button className="w-100">Continue</Button>
                  </Link>
                </div>
              </Col>
            ) : (
              <Col
                md="12"
                className=" d-flex flex-column justify-content-center align-items-center "
                style={{ height: "100vh" }}
              >
                <div>
                  <h3>Please add Data!</h3>
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ScannedQrcDetailsLostFound;
